import React, { Component } from 'react';
import ListOfServices from '../../components/services/ListOfServices';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import PopupBox from '../../components/shared/PopupBox';

class ServicesIndex extends Component {
  render() {
    const { match: { params } } = this.props;

    return (
      <div>
        <SetTitle title={"Services"} />
        <PopupBox />

        <h2 className="page-title">Services</h2>
        <OrganisationName />

        <div>
          <ListOfServices id={params.id} />
        </div>
      </div>
    );
  }
}

export default ServicesIndex;
